import { createDefaultQueryClient } from '@/src/lib/react-query/createDefaultQueryClient';

export const defaultQueryClient = createDefaultQueryClient();
